import React, { useState } from 'react';

// Components
import { WpSteps, WpStep } from '../';

const Steps2Docs = () => {
  const Horizontal = () => {
    return (
      <WpSteps activeStepNumber={2}>
        <WpStep title="Feedback Receivers" />
        <WpStep title="Feedback Providers" />
        <WpStep title="Due Dates" />
      </WpSteps>
    );
  };
  const Vertical = () => {
    return (
      <WpSteps activeStepNumber={2} direction="vertical">
        <WpStep title="Feedback Receivers" />
        <WpStep title="Feedback Providers" />
        <WpStep title="Due Dates" />
      </WpSteps>
    );
  };

  const VerticalWithOnClick = () => {
    const [activeStep, setActiveStep] = useState(1);

    return (
      <>
        <WpSteps activeStepNumber={activeStep} direction="vertical">
          <WpStep title="Feedback Receivers" onClick={() => setActiveStep(1)} />
          <WpStep title="Feedback Providers" onClick={() => setActiveStep(2)} />
          <WpStep title="Due Dates" onClick={() => setActiveStep(3)} />
        </WpSteps>

        <br />
        <h6>Step {activeStep} is active</h6>
      </>
    );
  };

  return (
    <>
      <h5 className="mb-3">Horizontal</h5>
      <Horizontal />

      <h5 className="mt-5 mb-3">Vertical</h5>
      <Vertical />

      <h5 className="mt-5 mb-3">Vertical With On Click Listener</h5>
      <VerticalWithOnClick />
    </>
  );
};

export default Steps2Docs;
